import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";

export const useCloseLead = (
	quoteID: number,
	closeReason: number,
	comment: string | undefined,
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("estimate/close", {
				quoteID: quoteID,
				closeReason: closeReason,
				comment: comment
			}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when closing the lead: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
